module.exports = __webpack_public_path__ + "img/yaoqingyonghu.feabbc76.png";